import styled from '@emotion/styled';
import { fontWeights } from '../../../app/typography';
import ListItem from './ListItem';
import { gray } from '@kizen/kds/Colors';

export default styled(ListItem)`
  cursor: default;
  color: ${gray['gray-600']};
  font-weight: ${fontWeights.bold};
  &:hover {
    background-color: unset; // Override ListItem hover style
  }
`;
